import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'
// 寫在此處是希望複用資料，以及讓資料能夠跨模組傳遞。
const serviceProvideModule = {
  state: {
    delSchedule: [], //拆機的行程表，判斷是否拆機用
    serviceProvideInfo: '', //讓title顯示 欠費中，停止服務
    stopWsModule: false, //控制告警彈窗要不要顯示
  },
  actions: {
    // 取得拆機清單
    async getDelSchedule({ commit, rootState }, searchParams) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.getDelSchedule.url,
          API.getDelSchedule.method,
          {
            ...searchParams,
            commulityId: currentCommunityId
          }
        )
        if (!res.isError && res.data) {
          // console.log('nvrData:'+JSON.stringify(res.data))
          commit('DEL_SCHEDULE', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
  },
  mutations: {
    DEL_SCHEDULE(state, payload) {
      state.delSchedule = payload
    },
    SERVER_PROVIDE_INFO(state, payload) {
      state.serviceProvideInfo = payload
    },
    STOP_WS_ALARM(state, payload) {
      state.stopWsModule = payload
    }
  },
  getters: {
    getDelSchedule: (state) => state.delSchedule,
    getServiceProvideInfo: (state) => state.serviceProvideInfo,
    getStopWsModule: (state) => state.stopWsModule
  },
  namespaced: true
}

export default serviceProvideModule